import { useEffect, useRef, useState } from 'react';

import { head, pick, pipe } from 'ramda';

import Text from 'components/shared/Typography/Text';
import { getIn, isDefined, isNotDefined } from 'utils/ramda';

const textProps = { accent: true, size: 'small' };

const toJSON = (value) => {
  if (isNotDefined(value)) return value;
  return JSON.parse(JSON.stringify(value));
};

const getDatasetValue = pipe(head, getIn('target.dataset'), toJSON, pick(['count', 'allCount']));

export const usePaginationsData = () => {
  const ref = useRef(null);
  const [paginationData, setPaginationData] = useState(null);

  useEffect(() => {
    const pdfPage = ref.current?.closest('.pdfPage');

    if (isDefined(pdfPage)) {
      const observer = new MutationObserver(pipe(getDatasetValue, setPaginationData));
      observer.observe(pdfPage, { attributes: true });

      return () => {
        observer.disconnect();
      };
    }
  }, []);

  return [ref, paginationData];
};

export const renderRightContentDefault = ({ paginationData }) => {
  if (isNotDefined(paginationData)) return '-';

  return <Text {...textProps}>{`${paginationData.count}/${paginationData.allCount}`}</Text>;
};
